import Stack from '@mui/material/Stack';
import React from 'react';
import CustomizedProgressBars from './ProgressBar';
import { mergeSx, Styles } from '@t2c/shared-fe';
import { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/system/useTheme';
import { Status } from '../@types';
import CustomLoader from '../components/custom-loader';
import { STATUS_REGISTRATION_REQUIREMENT } from '../utils';

interface Props {
  progressPercentage: number;
  status: string;
  isBrollCaption?: boolean;
  showStatusOnSuccess?: boolean;
}

export const StatusWithProgressBar: React.FC<Props> = ({
  progressPercentage,
  status,
  isBrollCaption,
  showStatusOnSuccess = false,
}) => {
  const theme = useTheme();
  const isError = status === Status.Error;
  const isSuccess = status === Status.Success;

  const successText = isBrollCaption ? 'Rendered' : 'Completed';
  const { registrationRequired } = STATUS_REGISTRATION_REQUIREMENT;

  const isInProgress = registrationRequired.includes(status);

  return (
    <Stack alignItems="center" sx={{ width: '100%' }}>
      {/* Show GIF when progressPercentage is 0 */}
      {progressPercentage === 0 && isInProgress && <CustomLoader />}

      {/* Progress Bar */}
      {progressPercentage >  0 && progressPercentage <= 100 && !(isError || isSuccess) && (
        <CustomizedProgressBars
          value={Math.floor(progressPercentage)}
          sx={{
            width: '100%',
          }}
          progressBarSx={{
            width: '100%',
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: '#fff',
            },
          }}
        />
      )}

      {/* Status Message */}
      {/* {(isError || (isSuccess && showStatusOnSuccess)) && (
        <Stack
          sx={mergeSx(styles.statusContainer, {
            background: isError ? theme.palette.error.main : theme.palette.success.main,
          })}
        >
          <Typography
            variant="body2"
            letterSpacing="0.5px"
            textAlign="center"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {isError ? 'Failed' : successText}
          </Typography>
        </Stack>
      )} */}
    </Stack>
  );
};

const styles: Styles = {
  statusContainer: {
    borderRadius: 20,
    width: '100%',
    py: 0.2,
    color: '#fff',
  },
};
